import '../App.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Helmet } from "react-helmet-async";
import { getPdfDownloadUrl } from '../utils/pdfApi';
import { HARPWOOD_WEBLINKS } from '../config/sharepointFundingPaths';

function SocialServicesFunding() {
  return (
    <>
    <Helmet>
        <title> Social Services Care Funding Accepted   </title>
        <meta
          name="description"
          content="We accept Social Services funding for our luxury suites. High-quality nursing care in Whitstable accessible to those with Local Authority support."
        />
        <link rel="canonical" href="https://www.harpwood.house/social-services-funding" />
      </Helmet>

    <div className="page">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Header />

      <main id="main-content">
        <section className="content-section self-funding-page">
          <div className="self-funding-container">
            <h1>Social Services Funding</h1>
          </div>
        </section>

        <section className="content-section self-funding-intro">
          <div className="section__container">
            <div className="section__text">
              <p>Current government policy is that individuals with less than £23,250 in savings and capital and lower income than the cost of their care may be eligible for funding from Social Services.</p>
              <p>We provide some places for people in this situation who have been assessed by Social Services as having on-going nursing needs.</p>
            </div>
          </div>
        </section>

        <section className="content-section self-funding-charges">
          <div className="section__container">
            <div className="section__text">
              <h2>Charges & Agreements</h2>
              <p>Our charges and associated documentation are as follows.   Please note that the "Residents Agreement" is particularly important as it explains the arrangements in detail together with the essential aspects of the agreements.</p>
            </div>
            <div className="section__text charges-content">
              <h3>Downloads</h3>
              <ul className="download-list">
                <li>
                <a href={getPdfDownloadUrl(HARPWOOD_WEBLINKS, 'Harpwood-Resident-Charges.pdf')} className="pdf-link" target="_blank" rel="noopener noreferrer">Residents' Charges (pdf)</a>
                </li>
                <li>
                  <a href={getPdfDownloadUrl(HARPWOOD_WEBLINKS, 'Harpwood Resident Agreement (SS Funding).pdf')} className="pdf-link" target="_blank" rel="noopener noreferrer">Resident Agreement – Social Services Funding (pdf)</a>
                </li>
                <li>
                <a href={getPdfDownloadUrl(HARPWOOD_WEBLINKS, 'Harpwood-Direct-Debit-Mandate.pdf')} className="pdf-link" target="_blank" rel="noopener noreferrer">Direct Debit Mandate (pdf)</a>
                </li>
              </ul>
            </div>
          </div>
        </section>

        <section className="content-section self-funding-capacity">
          <div className="section__container">
            <div className="section__text">
              <h2>Residents who lack capacity to consent to moving in</h2>
              <p>If a resident lacks capacity to sign documentation and a registered "Power of Attorney" is not in place, we ask for a personal guarantee from a third party to cover the charges until a Deputyship Order has been made and the account has been paid in full.  Our protocol for executing the Tenancy Agreement when a resident lacks mental capacity to give consent also needs to be followed.</p>
            </div>
            <div className="section__text capacity-content">
              <h3>Downloads</h3>
              <ul className="download-list">
                <li>
                <a href={getPdfDownloadUrl(HARPWOOD_WEBLINKS, 'Harpwood-3rd-Party-Personal-Guarantee.pdf')} className="pdf-link" target="_blank" rel="noopener noreferrer">3rd Party Personal Guarantee (pdf)</a>
                </li>
              </ul>
            </div>
          </div>
        </section>

        <section className="content-section self-funding-credit">
          <div className="section__container">
            <div className="section__text">
              <h2>Credit Terms</h2>
              <p>All charges for each month are payable in advance by Direct Debit on the first day of each month.  If accounts are not paid in accordance with these terms, action is taken in line with the following letters.</p>
            </div>
            <div className="section__text credit-content">
            <h3>Overdue Accounts</h3>
              
              <div className="overdue-accounts">
                <div className="overdue-item">
                  <p className="overdue-date">7th of the following month:</p>
                  <ul className="download-list">
                    <li>
                    <a href={getPdfDownloadUrl(HARPWOOD_WEBLINKS, 'Harpwood-1-Statement-of-Arrears.pdf')} className="pdf-link" target="_blank" rel="noopener noreferrer">Statement of Arrears (pdf)</a>
                    </li>
                  </ul>
                </div>
                
                <div className="overdue-item">
                  <p className="overdue-date">14th of the following month:</p>
                  <ul className="download-list">
                    <li>
                    <a href={getPdfDownloadUrl(HARPWOOD_WEBLINKS, 'Harpwood-2-Seven-day-warning-letter.pdf')} className="pdf-link" target="_blank" rel="noopener noreferrer">Seven Day Warning Letter (pdf)</a>
                    </li>
                  </ul>
                </div>
                
                <div className="overdue-item">
                  <p className="overdue-date">21st of the following month:</p>
                  <ul className="download-list">
                    <li>
                    <a href={getPdfDownloadUrl(HARPWOOD_WEBLINKS, 'Harpwood-3-Notification-of-Legal-Action-NH-Agreements.pdf')} className="pdf-link" target="_blank" rel="noopener noreferrer">Notification of Legal Action - Nursing Home Agreements (pdf)</a>
                    </li>
                  </ul>
                </div>
                
                <div className="overdue-item">
                  <p className="overdue-date">28th of the following month:</p>
                  <ul className="download-list">
                    <li>
                    <a href={getPdfDownloadUrl(HARPWOOD_WEBLINKS, 'Harpwood-4-Solicitors-Letter-Nursing-Home-Agreements.pdf')} className="pdf-link" target="_blank" rel="noopener noreferrer">Solicitor's Notice to Leave - Nursing Home Agreements (pdf)</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
    </>
  );
}

export default SocialServicesFunding;
